import styled from "styled-components";

import { colors } from "../../styles/colors";

type FilterItemsParams = {
  filterColor: keyof typeof colors;
};

export const Container = styled.button<FilterItemsParams>`
  filter: grayscale(100%);
  color: #acb9c1;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 150%;
  transition: all 0.3s;
  text-transform: capitalize;
  width: 100%;
  display: flex;
  align-items: center;

  img {
    padding-right: 2.5rem;
    width: 40px;
    height: 16px;
    display: block;
  }

  span {
    width: 100%;
    text-align: left;
  }

  &:hover,
  &.active {
    color: ${(props) => colors[props.filterColor]};
    filter: grayscale(0%);
  }
`;
